import React, { useState, useContext, useEffect } from "react";
import "./RequestQuote.css";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import moment from "moment";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Header from "../../Home/Header/Header";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Sidebar from "../../Home/Sidebar/Sidebar";
import { StoreContext } from "../../../../Store/Provider";
import Line from "../../../SVG/Line";
import PlaceDot from "../../../SVG/PlaceDot";
import { useNavigate } from "react-router-dom";
import { getUserData, localStoragekey } from "../../../Common/Utility/Utils";
import axios from "axios";
import { HOST_URL, ProjectName } from "../../../../Config";
import { NotificationManager } from "react-notifications";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import InquirySuccessModal from "../ScheduleSearchResult/InquirySuccessModal";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const BlueSwitch = withStyles({
  switchBase: {
    color: "#8596a2",
    "&$checked": {
      color: "rgba(var(--text-heading-dark))",
    },
    "&$checked + $track": {
      backgroundColor: "rgba(var(--text-heading-dark))",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#8596a2",
  },
})(Switch);

function RequestQuote(props) {
  const classes = useStyles();
  const [state, setState] = useState({
    pickContainer: false,
    oversizedCargo: false,
    dangerousCargo: false,
  });
  const [shpType, setShpType] = useState("FCL");
  const [inputValue, setInputValue] = useState({
    weight: "",
    commodity: "",
    quantity: "",
  });
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const context = useContext(StoreContext);
  const history = useNavigate();
  const [openmodal, setOpenmodal] = useState(false);
  const handleCloseModal = () => {
    setOpenmodal(false);
    history(routeConstant.Schedule);
  };
  function testInput(event) {
    var value = String.fromCharCode(event.which);
    var pattern = new RegExp(/[a-zåäö ]/i);
    return pattern.test(value);
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleChangeInput = (e) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value });
  };

  const handleShpType = (e) => {
    setShpType(e.target.value);
  };

  const resetFilters = () => {
    setState({
      pickContainer: false,
      oversizedCargo: false,
      dangerousCargo: false,
    });
    setShpType("FCL");
    setInputValue({
      weight: "",
      commodity: "",
      quantity: "",
    });
  };
  const requestQuote = async () => {
    if (!inputValue.weight) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill Weight!");
    } else if (!/^\d+$/.test(inputValue.weight)) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill correct Weight!");
    } else if (!inputValue.commodity) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill Commodity!");
    } else if (!inputValue.quantity) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill Quantity/Volume!");
    } else if (!/^\d+$/.test(inputValue.quantity)) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill correct Quantity/Volume!");
    } else {
      let userData = {};
      await getUserData(localStoragekey)
        .then((res) => {
          userData = res;
        })
        .catch((err) => {
          console.log(err);
          userData = {};
        });
      const header = {
        Authorization: `Bearer ${userData.access_token}`,
        username: `${userData.userName}`,
        grant_type: "password",
        password: `${userData.userSecret}`,
      };

      const end_point = `${HOST_URL}api/v1/Shipment/REQUESTQUOTE`;
      const email = JSON.parse(localStorage.getItem(localStoragekey))?.EMail;
      const orgs = JSON.parse(localStorage.getItem(localStoragekey))?.orgs;
      const params = {
        RequestQuote_EMail: email,
        RequestQuote_Organization: orgs,
        RequestQuote_OriginCountry: context.requestQuote.origincountry,
        RequestQuote_OriginPort: `${context.requestQuote.OriginPortFullName} (${context.requestQuote.OriginPort})`,
        RequestQuote_DestinationCountry:
          context.requestQuote.destinationCountry,
        RequestQuote_DestinationPort: `${context.requestQuote.destinationPortFullName} (${context.requestQuote.destinationPort})`,
        RequestQuote_ForDate: context.requestQuote.selectedDate,
        RequestQuote_AorD: context.requestQuote.availvableDirectionShort,
        RequestQuote_Carrier:
          context.transportmodeglobal === "SEA"
            ? context.dataQuote?.compName ?? ""
            : "",
        RequestQuote_ContainerType: shpType,
        RequestQuote_TransportMode: context.transportmodeglobal,
        RequestQuote_Details: JSON.stringify(
          context.transportmodeglobal === "SEA"
            ? context.dataQuote?.data?.transShipments
            : context.transportmodeglobal === "AIR"
            ? context.dataQuote.data
            : null
        ),
        RequestQuote_Vessel: "",
        RequestQuote_Voyage: "",
        RequestQuote_Weight: inputValue.weight,
        RequestQuote_Commodity: inputValue.commodity,
        RequestQuote_Volume: inputValue.quantity,
        RequestQuote_PickFromOtherCity: state.pickContainer ? "YES" : "NO",
        RequestQuote_Oversized: state.oversizedCargo ? "YES" : "NO",
        RequestQuote_Dangerous: state.dangerousCargo ? "YES" : "NO",
        RequestQuote_WeeksAhead: context.requestQuote.weekAhead,
      };

      axios
        .post(end_point, params, {
          headers: header,
        })
        .then((res) => {
          if (res.data.Success) {
            setOpenmodal(true);
          } else {
            NotificationManager.error(res.data.ResultMessage, "", 3000);
          }
        })
        .catch((err) => {
          NotificationManager.error("Something went wrong", "", 3000);
        });
    }
  };

  let date = new Date(0);
  date.setUTCSeconds(context.dataQuote.data?.cutOff ?? "");
  const cutoffdate = moment(date).format("DD/MM/YYYY");

  if (context.dataQuote.data) {
    return (
      <div className="home">
        <InquirySuccessModal open={openmodal} handleClose={handleCloseModal} />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert severity={severity} onClose={handleClose}>
            {alertText}
          </Alert>
        </Snackbar>
        <Header />
        <div className="shipmentsListingHome">
          <Drawer
            variant="persistent"
            className={clsx(classes.drawerLeft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            })}
            classes={{
              paper: clsx(classes.drawerPaperleft, {
                [classes.drawerOpen]: context.menuBar,
                [classes.drawerClose]: !context.menuBar,
              }),
            }}
          >
            <Sidebar />
          </Drawer>
          <main className={clsx(classes.content)}>
            <div className="scheduleSearchResultScreen container">
              <div className="scheduleSearchResultScreenHeadingDiv my-2">
                <h6
                  className="scheduleSearchResultScreenHeading pointer"
                  onClick={() => {
                    history(-1);
                  }}
                >
                  <ArrowBackIosIcon /> Go Back Search Results
                </h6>
              </div>
              <div className="scheduleSearchResultScreenSubHeadingDiv my-2">
                <div className="scheduleSearchResultScreenSubHeadingDivLeft">
                  <img
                    src={`/${ProjectName}/Assets/Images/SailingScheduleResult.svg`}
                    alt="SailingScheduleResult"
                  />
                  <div>
                    <span>Sailing schedule</span>
                    <p>
                      Start scheduling your shipment and <br /> send your cargo
                      anywhere in the world.
                    </p>
                  </div>
                </div>
                {context.searchResult.length ? (
                  <div className="scheduleSearchResultScreenSubHeadingDivRight shipmentDetailsDiv ">
                    <div className="shpDetailsRouteDiv">
                      <div className="shptimelinebody">
                        <span title={context.requestQuote.OriginPort}>
                          {context.requestQuote.OriginPort}
                        </span>
                        <div className="shptimelinecontainer">
                          <span>
                            <PlaceDot
                              colorCode={"rgba(var(--text-heading-light))"}
                            />
                          </span>
                          <span>
                            <PlaceDot
                              colorCode={"rgba(var(--text-heading-light))"}
                            />
                          </span>
                          <Line
                            colorCode={"rgba(var(--text-heading-light))"}
                            classDotted={"dottedline"}
                          />
                        </div>
                        <span title={context.requestQuote.destinationPort}>
                          {context.requestQuote.destinationPort}
                        </span>
                      </div>
                      <p className="etdEtap">
                        <span title={context.requestQuote.OriginPortFullName}>
                          {context.requestQuote.OriginPortFullName}
                        </span>
                        <span
                          title={context.requestQuote.destinationPortFullName}
                        >
                          {context.requestQuote.destinationPortFullName}
                        </span>
                      </p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="scheduleSearchResultBodyInner">
                <div className="scheduleSearchcardbody my-3">
                  <div className="scheduleSearchcardbodyCommon mb-2 pb-2">
                    <div className="scheduleSearchcardbodyInner">
                      {context.transportmodeglobal === "SEA" ? (
                        <>
                          <div className="scheduleSearchcardInner compdetails ps-0">
                            <img
                              src={
                                context.dataQuote.logo ?? context.dataQuote.logo
                              }
                              alt="company logo"
                            />
                            <span>
                              {context.dataQuote.compName ??
                                context.dataQuote.compName}
                            </span>
                          </div>
                          <div className="scheduleSearchcardInner commondetails">
                            <span>TRANSIT DAYS</span>
                            <p>{context.dataQuote.data.transitTime} Days</p>
                          </div>
                          <div className="scheduleSearchcardInner commondetails">
                            <span>ETA</span>
                            <p>{cutoffdate}</p>
                          </div>
                        </>
                      ) : null}

                      <div className="scheduleSearchcardInner requestQuote quoteRequest"></div>
                    </div>
                  </div>
                  {context.transportmodeglobal === "SEA" ? (
                    <div className="scheduleSearchcardbodyItterarte">
                      {context.dataQuote.data?.transShipments.map(
                        (transShipments) => {
                          let etdDate = new Date(0);
                          etdDate.setUTCSeconds(transShipments.departure.date);
                          const etd = moment(etdDate).format("DD/MM/YYYY");
                          let etaDate = new Date(0);
                          etaDate.setUTCSeconds(transShipments.arrival.date);
                          const eta = moment(etaDate).format("DD/MM/YYYY");
                          return (
                            <div className="scheduleSearchcardbodyInner">
                              <div className="scheduleSearchcardInner commondetails ps-0">
                                <span>Vessel</span>
                                <p title={transShipments.vesselName}>
                                  {!transShipments.vesselName &&
                                  transShipments.vesselName === null
                                    ? "N/A"
                                    : transShipments.vesselName}
                                </p>
                              </div>
                              <div className="scheduleSearchcardInner commondetails">
                                <span>Service</span>
                                <p title={transShipments.service}>
                                  {!transShipments.service &&
                                  transShipments.service === null
                                    ? "N/A"
                                    : transShipments.service}
                                </p>
                              </div>
                              <div className="scheduleSearchcardInner commondetails">
                                <span>ETD</span>
                                <p>{!etd && etd !== null ? "N/A" : etd}</p>
                              </div>
                              <div className="scheduleSearchcardInner commondetails">
                                <span>ETA</span>
                                <p>{!eta && eta !== null ? "N/A" : eta}</p>
                              </div>
                              <div className="scheduleSearchcardInner milecol">
                                <div className="searchshptimelineBody">
                                  <span>ORIGIN</span>
                                  <div className="searchshptimelinecontainer">
                                    <span>
                                      <PlaceDot
                                        colorCode={
                                          "rgba(var(--text-heading-light))"
                                        }
                                      />
                                    </span>
                                    <span>
                                      <PlaceDot
                                        colorCode={
                                          "rgba(var(--text-heading-light))"
                                        }
                                      />
                                    </span>
                                    <Line
                                      colorCode={
                                        "rgba(var(--text-heading-light))"
                                      }
                                      classDotted={"dottedline"}
                                    />
                                  </div>
                                  <span>DESTINATION</span>
                                </div>
                                <p>
                                  <span
                                    title={transShipments.departure.portName}
                                  >
                                    {transShipments.departure.portName}
                                  </span>
                                  <span title={transShipments.arrival.portName}>
                                    {transShipments.arrival.portName}
                                  </span>
                                </p>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : context.transportmodeglobal === "AIR" ? (
                    <div className="scheduleSearchcardbodyItterarte">
                      <div
                        key={context.dataQuote.data.ident_iata}
                        className="scheduleSearchcardbody"
                      >
                        <div className="scheduleSearchcardbodyItterarte">
                          <div className="scheduleSearchcardbodyInner">
                            <div className="scheduleSearchcardInner commondetails ps-0">
                              <span>Flight</span>
                              <p title={context.dataQuote.data.ident_iata}>
                                {!context.dataQuote.data.ident_iata &&
                                context.dataQuote.data.ident_iata === null
                                  ? "N/A"
                                  : context.dataQuote.data.ident_iata}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>Aircraft Type</span>
                              <p title={context.dataQuote.data.aircraft_type}>
                                {!context.dataQuote.data.aircraft_type &&
                                context.dataQuote.data.aircraft_type === null
                                  ? "N/A"
                                  : context.dataQuote.data.aircraft_type}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>ETD</span>
                              <p>
                                {!context.dataQuote.data.scheduled_in &&
                                context.dataQuote.data.scheduled_in !== null
                                  ? "N/A"
                                  : moment(
                                      context.dataQuote.data.scheduled_in
                                    ).format("DD/MM/YYYY")}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>ETA</span>
                              <p>
                                {!context.dataQuote.data.scheduled_out &&
                                context.dataQuote.data.scheduled_out !== null
                                  ? "N/A"
                                  : moment(
                                      context.dataQuote.data.scheduled_out
                                    ).format("DD/MM/YYYY")}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner milecol">
                              <div className="searchshptimelineBody">
                                <span>ORIGIN</span>
                                <div className="searchshptimelinecontainer">
                                  <span>
                                    <PlaceDot
                                      colorCode={
                                        "rgba(var(--text-heading-light))"
                                      }
                                    />
                                  </span>
                                  <span>
                                    <PlaceDot
                                      colorCode={
                                        "rgba(var(--text-heading-light))"
                                      }
                                    />
                                  </span>
                                  <Line
                                    colorCode={
                                      "rgba(var(--text-heading-light))"
                                    }
                                    classDotted={"dottedline"}
                                  />
                                </div>
                                <span>DESTINATION</span>
                              </div>
                              <p>
                                <span
                                  title={context.dataQuote.data.origin_iata}
                                >
                                  {context.dataQuote.data.origin_iata}
                                </span>
                                <span
                                  title={
                                    context.dataQuote.data.destination_iata
                                  }
                                >
                                  {context.dataQuote.data.destination_iata}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="container-fluid reqQuoteFilters my-3">
                  <div className="row reqQuoteFiltersRow reqQuoteFiltersInnerF">
                    <div className="col-md-3 col-sm-6 col-12">
                      <label className="form-label">Shipment Type*</label>
                      {context.transportmodeglobal === "SEA" ? (
                        <select
                          className="form-select"
                          value={shpType}
                          onChange={handleShpType}
                        >
                          <option value="Sea Freight LCL">
                            Sea Freight LCL
                          </option>
                          <option value="Sea Freight FCL">
                            Sea Freight FCL
                          </option>
                          <option value="Sea Break Bulk">Sea Break Bulk</option>
                          <option value="Sea Roll On/Roll OFF">
                            Sea Roll On/Roll OFF
                          </option>
                          <option value="Sea Liquid">Sea Liquid</option>
                        </select>
                      ) : context.transportmodeglobal === "AIR" ? (
                        <select
                          className="form-select"
                          value={shpType}
                          onChange={handleShpType}
                        >
                          <option value="Air Freight LSE">
                            Air Freight LSE
                          </option>
                          <option value="Air Freight ULD">
                            Air Freight ULD
                          </option>
                        </select>
                      ) : null}
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                      <label className="form-label">Weight* (kg)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="weight"
                        value={inputValue.weight}
                        placeholder="Weight"
                        onChange={handleChangeInput}
                      />
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                      <label className="form-label">Commodity*</label>
                      <input
                        type="text"
                        onClick={(event) => testInput(event)}
                        className="form-control"
                        id="my-field"
                        name="commodity"
                        value={inputValue.commodity}
                        placeholder="Commodity"
                        onChange={handleChangeInput}
                      />
                    </div>
                    <div className="col-md-3 col-sm-6 col-12">
                      <label className="form-label">
                        Quantity/Volume* (m<sup>3</sup>)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="quantity"
                        value={inputValue.quantity}
                        placeholder="Quantity/Volume"
                        onChange={handleChangeInput}
                      />
                    </div>
                  </div>
                </div>
                <div className="container-fluid reqQuoteFilters my-3">
                  <div className="row reqQuoteFiltersRow  reqQuoteFiltersInnerL">
                    <div className="col-sm-6 col-12 labelSwitch">
                      <FormControlLabel
                        labelPlacement="start"
                        control={
                          <BlueSwitch
                            checked={state.pickContainer}
                            onChange={handleChange}
                            name="pickContainer"
                          />
                        }
                        label={
                          <span>
                            Pick up the empty container(s) in another city
                          </span>
                        }
                      />
                    </div>
                    <div className="col-md-3 col-sm-6 col-12 labelSwitch">
                      <FormControlLabel
                        labelPlacement="start"
                        control={
                          <BlueSwitch
                            checked={state.oversizedCargo}
                            onChange={handleChange}
                            name="oversizedCargo"
                          />
                        }
                        label="Oversized Cargo"
                      />
                    </div>
                    <div className="col-md-3 col-sm-6 col-12 labelSwitch">
                      <FormControlLabel
                        labelPlacement="start"
                        control={
                          <BlueSwitch
                            checked={state.dangerousCargo}
                            onChange={handleChange}
                            name="dangerousCargo"
                          />
                        }
                        label="Dangerous Cargo"
                      />
                    </div>
                  </div>
                </div>
                <div className="quoteRequest pt-3 pb-2">
                  <Button
                    variant="contained"
                    className="me-5"
                    onClick={resetFilters}
                  >
                    Reset
                  </Button>
                  <Button variant="contained" onClick={() => requestQuote()}>
                    Request Quote
                  </Button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  } else {
    return (
      <button className="hide" onClick={() => history("/Home/RequestQuote")}>
        Previous
      </button>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default RequestQuote;
